export default __webpack_public_path__ + "static/media/avatar4.4fcbb17f.png";